import connector from "@/repository/connector";

export default {
  async getUsdToRub() {
    const data = await connector.requestWithFallback(
      () => connector.connector.get("currency-rate/usd/")
    );
    if (typeof data === "number" && Number.isFinite(data)) return data;
    const rate =
      data?.rate ?? data?.rub ?? data?.usd_rub ?? data?.value ?? data?.amount;
    return Number(rate) || 0;
  },
};
